<template>
    <el-dialog
        class="leader-dialog"
        :title="title"
        :visible.sync="addshow"
        :close-on-click-modal="false"
        @close="closeDialog"
        width="1000px"
    >
        <el-scrollbar style="height: 470px">
            <div style="display: flex; height: 100%">
                <div style="height: 470px; width: 300px">
                    <div class="tree-wrap">
                        <me-tree
                            ref="myTree"
                            :defaultProps="defaultProps"
                            :treeData="treeList"
                            :nodeKey="'tree_id'"
                            :isSingle="false"
                            :showCheckbox="true"
                            :isCheckClick="true"
                            :checkStrictly="true"
                            :treeLoading="treeLoading"
                            :treeToolBar="false"
                            :default-expand-all="true"
                            @handleCheckBoxClick="handleTreeNodeClick"
                        ></me-tree>
                    </div>
                </div>
                <el-form
                    :rules="formRules"
                    class="leader-style-form"
                    :model="addForm"
                    ref="addForm"
                    :show-message="false"
                >
                    <div v-if="'2' == isnew">
                        <el-form-item
                            label="报修核实情况"
                            :label-width="formLabelWidth"
                            prop="check_content"
                        >
                            <el-input
                                type="textarea"
                                :rows="5"
                                placeholder="请输入报修核实情况"
                                v-model="addForm.check_content"
                            ></el-input>
                        </el-form-item>
                    </div>
                    <div v-else>
                        <el-form-item
                            label="设备名称"
                            :label-width="formLabelWidth"
                            prop="service_area_idAdd"
                        >
                            <el-input placeholder="请选择设备" v-model="tree_Names" :disabled="true"></el-input>
                        </el-form-item>
                        <div class="childForm_mr10 childForm_w50 space_between h70">
                            <el-form-item
                                label="报修时间"
                                :label-width="formLabelWidth"
                                prop="report_repair_date"
                            >
                                <el-date-picker
                                    v-model="addForm.report_repair_date"
                                    type="datetime"
                                    :disabled="isBackFill"
                                    placeholder="选择日期"
                                    :default-value="timeNow"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    style="width: 100%;"
                                    @change="gettime"
                                ></el-date-picker>
                            </el-form-item>
                            <el-form-item label="报修人" :label-width="formLabelWidth" prop="reporter">
                                <el-input
                                    type="text"
                                    placeholder="请输入报修人"
                                    v-model="addForm.reporter"
                                ></el-input>
                            </el-form-item>
                        </div>
                        <div class="childForm_mr10 childForm_w50 space_between h70" v-if="false">
                            <el-form-item
                                label="设备名称"
                                :label-width="formLabelWidth"
                                prop="service_area_idAdd"
                            >
                                <el-select
                                    v-model="addForm.service_area_idAdd"
                                    @change="getDeviceListByData"
                                >
                                    <el-option
                                        v-for="item in serviceAreaJson"
                                        :key="item.service_area_id"
                                        :label="item.service_area_name"
                                        :value="item.service_area_id"
                                    ></el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item
                                label="设备号"
                                :label-width="formLabelWidth"
                                prop="device_typeAdd"
                            >
                                <el-select
                                    v-model="addForm.device_typeAdd"
                                    :disabled="deviceTypeDisabled"
                                    @change="getDeviceListByData"
                                >
                                    <el-option
                                        v-for="item in device_typeJson"
                                        :key="item.code_value"
                                        :label="item.code_name"
                                        :value="item.code_value"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="childForm_mr10 childForm_w50 space_between h70">
                            <el-form-item
                                label="报修来源"
                                :label-width="formLabelWidth"
                                prop="report_repair_source"
                            >
                                <el-select
                                    v-model="addForm.report_repair_source"
                                    @change="getDeviceListByData"
                                >
                                    <el-option
                                        v-for="item in stateList"
                                        :key="item.stateCode"
                                        :label="item.stateName"
                                        :value="item.stateCode"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item
                                label="联系电话"
                                :label-width="formLabelWidth"
                                prop="reporter_phone"
                            >
                                <el-input
                                    type="text"
                                    placeholder="请输入联系电话"
                                    v-model="addForm.reporter_phone"
                                ></el-input>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item
                                label="报修描述"
                                :label-width="formLabelWidth"
                                prop="describe"
                            >
                                <el-input
                                    type="textarea"
                                    :rows="2"
                                    placeholder="请输入报修描述"
                                    v-model="addForm.describe"
                                ></el-input>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item
                                label="报修图片"
                                :label-width="formLabelWidth"
                                prop="device_typeAdd"
                            >
                                <!--                            <div v-if="isBackFill">-->
                                <!--                                <img :src="addForm.fj_path" class="avatar">-->
                                <!--                            </div>-->
                                <div>
                                    <el-upload
                                        class="avatar-uploader"
                                        action
                                        :http-request="uploadFile"
                                        list-type="picture-card"
                                        :file-list="qxFileImgs"
                                        :on-remove="handleRemove"
                                        :class="{ disabled: uploadDisabled }"
                                        accept=".jpg, , jpeg, .png, .gif, .bmp"
                                    >
                                        <i class="el-icon-plus"></i>
                                    </el-upload>
                                </div>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>
            </div>
        </el-scrollbar>
        <div slot="footer" class="dialog-footer">
            <el-button @click="addshow = false" class="leader-common-button">取消</el-button>
            <el-button
                type="primary"
                class="leader-common-button"
                @click="addcommit('addForm')"
                :loading="this.$store.state.btnType"
            >提交</el-button>
        </div>
    </el-dialog>
</template>
<script>
import * as api from '../api/index';
import Bus from '@/utils/eventBus.js';
import Tree from '@/comon/components/tree.vue';

export default {
    components: {
        'me-tree': Tree,
    },
    props: {
        addshow: {
            type: Boolean,
        },
        isnew: {
            type: String,
        },
        tree_Names: {
            type: String,
        },
        tree_ids: {
            type: String,
        },
        chooseRow: {
            type: Object,
        },
    },
    watch: {
        addshow(newVal) {
            if (newVal) {
                switch (this.isnew) {
                    case '0':
                        this.title = '新增';
                        // this.addForm.reporter = "";
                        // this.addForm.reporter_phone = "";
                        // this.addForm.describe = "";
                        // this.addForm.check_content = "";
                        this.$nextTick(() => {
                            this.$refs['addForm'].resetFields();
                            this.addForm.file_path = '';
                            this.addForm.pub_file_id = '';
                            this.qxFileImgs = [];
                            this.$refs.myTree.$refs.tree.setCheckedKeys([]);
                        });
                        break;
                    case '1':
                        this.title = '修改';
                        this.selectReportRepairInfo();
                        break;
                    case '2':
                        this.title = '核实情况';
                        break;
                }
                this.getPointTree();
            }
        },
    },
    computed: {
        uploadDisabled: function () {
            return (
                this.addForm.pub_file_id && this.addForm.pub_file_id.length > 0
            );
        },
    },
    data() {
        return {
            formLabelWidth: '120px',
            //新增弹窗数据块
            addForm: {
                report_repair_date: '',
                reporter: '',
                reporter_phone: '',
                describe: '',
                report_repair_source: '',
                pub_file_id: '',
                file_path: '',
                //核实情况
                check_content: '',
            },
            treeList: [],
            treeLoading: false,
            // tree_id: "1",
            defaultProps: {
                children: 'childList',
                label: 'tree_name',
            },
            tree_ids: '',
            tree_Names: '',
            title: '新增',
            qxFileImgs: [],
            formRules: {
                report_repair_date: [
                    {
                        required: true,
                        message: '请选择报修时间',
                        trigger: 'change',
                    },
                ],
                report_repair_source: [
                    {
                        required: true,
                        message: '请选择报修来源',
                        trigger: 'change',
                    },
                ],
                reporter: [
                    {
                        required: true,
                        message: '请输入报修人',
                        trigger: 'blur',
                    },
                ],
                reporter_phone: [
                    {
                        required: true,
                        message: '请输入报修电话',
                        trigger: 'blur',
                    },
                ],
                describe: [
                    {
                        required: true,
                        message: '请输入报修描述',
                        trigger: 'blur',
                    },
                ],
                check_content: [
                    {
                        required: true,
                        message: '请输入核实情况',
                        trigger: 'blur',
                    },
                ],
            },
            stateList: [
                {
                    stateName: '电话报修',
                    stateCode: '10',
                },
                {
                    stateName: 'APP报修',
                    stateCode: '20',
                },
            ],
        };
    },
    methods: {
        closeDialog() {
            //清空输入数据
            this.addForm.report_repair_date = '';
            this.addForm.report_repair_source = '';
            this.addForm.reporter = '';
            this.addForm.reporter_phone = '';
            this.addForm.describe = '';
            this.addForm.check_content = '';
            this.addshow = false;
            this.$emit('update:addshow', this.addshow);
        },
        getPointTree() {
            this.treeLoading = true;
            api.getUnitDocTreeList().then((res) => {
                if (res) {
                    this.treeList = res.bus_json;
                }
                this.treeLoading = false;
            });
        },
        handleTreeNodeClick(select) {
            (this.tree_ids = ''),
                this.$refs.myTree.$refs.tree
                    .getCheckedKeys()
                    .forEach((item) => {
                        this.tree_ids += item + ',';
                    });
            if (this.tree_Names.match(select.tree_name)) {
                //判断若已经包含当前选择id，则表示当前操作为取消选择，故把当前节点去掉
                this.tree_Names = this.tree_Names.replace(
                    select.tree_name + ',',
                    ''
                );
            } else {
                this.tree_Names += select.tree_name + ',';
            }
        },
        addcommit() {
            if (this.tree_Names.length == 0) {
                this.$message('请先选择设备！');
                return;
            }
            this.$refs['addForm'].validate((valid) => {
                if (valid) {
                    this.$confirm('确认提交该数据?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                    })
                        .then(() => {
                            if ('2' == this.isnew) {
                                this.updateCheckContent();
                            } else {
                                this.insertRepair();
                            }
                        })
                        .catch((e) => {
                            this.$message({
                                type: 'info',
                                message: '未提交',
                            });
                        });
                }
            });
        },
        insertRepair() {
            if ('0' == this.isnew) {
                if (this.tree_ids.length > 1) {
                    this.tree_ids = this.tree_ids.substring(
                        0,
                        this.tree_ids.lastIndexOf(',')
                    );
                }
            }
            api.insertRepair({
                report_repair_id: this.chooseRow.report_repair_id,
                tree_id_list: this.tree_ids,
                report_repair_date: this.addForm.report_repair_date,
                report_repair_source: this.addForm.report_repair_source,
                reporter: this.addForm.reporter,
                reporter_phone: this.addForm.reporter_phone,
                describe: this.addForm.describe,
                check_content: this.addForm.check_content,
                pub_file_id: this.addForm.pub_file_id,
            }).then((res) => {
                if (res.error_code == '0') {
                    this.$message({
                        message: '提交成功！',
                        type: 'success',
                    });
                    //清空输入数据
                    this.addForm.report_repair_date = '';
                    this.addForm.report_repair_source = '';
                    this.addForm.reporter = '';
                    this.addForm.reporter_phone = '';
                    this.addForm.describe = '';
                    this.addForm.check_content = '';
                    this.addForm.pub_file_id = '';

                    //通知前页对话框关闭
                    this.addshow = false;
                    this.$emit('update:addshow', this.addshow);
                    Bus.$emit('refresh', this.addshow);
                } else {
                    this.$message({
                        message: res.bus_json,
                        type: 'error',
                    });
                }
            });
        },
        selectReportRepairInfo() {
            api.selectReportRepairInfo({
                report_repair_id: this.chooseRow.report_repair_id,
            }).then((res) => {
                if (res.error_code == '0') {
                    //清空输入数据
                    this.addForm.report_repair_date =
                        res.bus_json.report_repair_date;
                    this.addForm.reporter = res.bus_json.reporter;
                    this.addForm.reporter_phone = res.bus_json.reporter_phone;
                    this.addForm.describe = res.bus_json.describe;
                    this.addForm.report_repair_source =
                        res.bus_json.report_repair_source;
                    this.addForm.file_path = res.bus_json.file_path;
                    this.addForm.pub_file_id = res.bus_json.pub_file_id;
                    this.qxFileImgs = [
                        {
                            file_id: res.bus_json.pub_file_id,
                            url:
                                process.env.VUE_APP_3D_URL +
                                '/' +
                                res.bus_json.file_path,
                        },
                    ];
                    this.tree_ids = res.bus_json.tree_id_list;
                    this.tree_Names = res.bus_json.tree_id_list_tree_name;
                    this.$nextTick(() => {
                        this.$refs.myTree.$refs.tree.setCheckedKeys([
                            ...res.bus_json.tree_id_list.split(','),
                        ]);
                    });
                } else {
                }
            });
        },
        updateCheckContent() {
            api.updateCheckContent({
                report_repair_id: this.chooseRow.report_repair_id,
                check_content: this.addForm.check_content,
            }).then((res) => {
                if (res.error_code == '0') {
                    this.$message({
                        message: '提交成功！',
                        type: 'success',
                    });
                    //清空输入数据
                    this.addForm.report_repair_date = '';
                    this.addForm.reporter = '';
                    this.addForm.reporter_phone = '';
                    this.addForm.describe = '';
                    this.addForm.check_content = '';

                    //通知前页对话框关闭
                    this.addshow = false;
                    this.$emit('update:addshow', this.addshow);
                    Bus.$emit('refresh', this.addshow);
                } else {
                }
            });
        },
        handleRemove(file) {
            this.addForm.pub_file_id = '';
            this.qxFileImgs = [];
        },
        // 图片上传
        uploadFile(file) {
            const isLt2M = file.file.size / 1024 / 1024 < 1;
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 1MB!,请重新上传！');
                return;
            }
            let formData = new FormData();
            formData.append('file', file.file);
            formData.append('file_type', '50');
            api.uploadAvatar(formData).then((res) => {
                if (res) {
                    this.addForm.pub_file_id = res.bus_json.file_id;
                    this.qxFileImgs.push({
                        file_id: item.file_id,
                        url: process.env.VUE_APP_3D_URL + '/' + item.file_path,
                    });
                    this.$message({
                        type: 'success',
                        message: res.error_msg,
                    });
                }
            });
        },
    },
};
</script>
<style lang="scss">
.reprot_repair_add_class {
    .avatar-uploader {
        text-align: left;

        .el-upload--picture-card {
            background-color: transparent;
        }
    }
    .avatar-uploader {
        .el-upload--picture-card {
            width: 100px;
            height: 100px;
            line-height: 100px;
            background-color: transparent;
        }

        .el-upload-list--picture-card .el-upload-list__item {
            width: 100px;
            height: 100px;
        }
    }

    .disabled .el-upload--picture-card {
        display: none;
    }
}
</style>
